module.exports = __webpack_public_path__ + "static/media/ios-whatsapp-config.f635bdd9.svg";